import React from 'react'
import { InstagramBrand } from 'blaze-ui/icons/24'
import { FacebookBrand } from 'blaze-ui/icons/35'
import { Plus02 } from 'blaze-ui/icons/20'
import { Button } from 'blaze-ui/Button'
import Styles from './StyledIntegrationButton.module.scss'

interface StyledIntegrationButtonProps {
  provider: 'instagram' | 'facebook'
}

export const StyledIntegrationButton: React.FC<StyledIntegrationButtonProps> = ({ provider }) => {
  const isInstagram = provider === 'instagram'

  return (
    <Button className={`${Styles.card} ${isInstagram ? Styles.instagram : Styles.facebook}`} useChildClass>
      <div className={Styles.frame}>
        <div className={Styles.brandLogo}>{isInstagram ? <InstagramBrand /> : <FacebookBrand />}</div>
        <div className={Styles.textWrapper}>
          <div className={Styles.text}>
            <div>Connect</div>
            <div>{isInstagram ? 'Instagram' : 'Facebook'}</div>
          </div>
        </div>
        <div className={Styles.button}>
          <Plus02 size={20} color="var(--light-100)" />
        </div>
      </div>
    </Button>
  )
}
